import React, {createRef, useEffect, useRef, useState} from "react";
const classNames = require('classnames');

interface TabsProps {
    tabs: Array<string>,
    onChange: (index: number) => void,
    fixed?: boolean,
    onFixed?:(status:boolean) => void,
    mask?:boolean
}


function Tabs({tabs, onChange, fixed = false,onFixed,mask = true}: TabsProps) {

    const box = useRef(null)

    const [position, setPosition] = useState(fixed)
    const [active, setActive] = useState(0)

    useEffect(() => {
        if (!fixed) {

            const scrollHandle = () => {
                const s_t = document.querySelector('.tabs');
                if (s_t) {
                    const box = s_t.getBoundingClientRect()
                    // console.log(box)
                    if (box.top <= 0 && !position) {
                        setPosition(true)
                    } else {
                        !position && setPosition(false)
                    }
                }
            }

            window.addEventListener("scroll", scrollHandle, false)

            return () => {
                window.removeEventListener("scroll", scrollHandle, false)
            }
        }
    }, [])

    useEffect(() => {
        if(tabs.length > 0){
            onChange(active)
        }
    }, [active])

    useEffect(() => {
        if(onFixed){
            onFixed(position)
        }
    },[position])

    useEffect(() => {
        let width = window.innerWidth;
        let scrollWidth = 0;
        // @ts-ignore
        Array.from(box.current.children).forEach(item => {
            scrollWidth+=(item as HTMLDivElement).getBoundingClientRect().width
        })

        if(scrollWidth > width){
            // @ts-ignore
            box.current.style.width = Math.ceil(scrollWidth) + 'px';
        }

    },[tabs])


    return <div className="tabs">
        <div className={classNames('box',{'_fixed':position,'mask':mask})} >
            <div className="scroll-handle">
                <div className="scroll-x" ref={ box }>
                    {
                        tabs.map((item, index) => {
                            return <div className={ active === index ? 'tab-item active' : 'tab-item' } key={index} onClick={() => setActive(index)}>
                                <p>{item}</p>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    </div>
}

export default Tabs;
